export const IconMapping = {
    // Screens
    '/screens/screen-list': 'fal fa-tv',
    '/screens': 'fal fa-tachometer-alt',
    '/screens/dashboard': 'fal fa-tachometer-alt',
    '/screens/playlist': 'fal fa-layer-group',
    '/screens/multimedia': 'fal fa-images',
    '/screens/audiolist': 'fal fa-list-music',
    '/screens/template-list': 'fal fa-vector-square',
    '/screens/screens-scheduling': 'fal fa-calendar-alt',
    '/screens/groups-scheduling': 'fal fa-folder',
    '/screens/screen-download-scheduling': 'fal fa-download',
    '/screens/location-list': 'fal fa-map-marker-alt',
    '/screens/groups': 'fal fa-folder',
    '/screens/reports': 'fal far fa-chart-line',
    '/screens/dynamic-information-tables': 'fal fa-th-list',
    '/screens/data-client-list': 'fal fa-satellite',
    '/screens/software-versions': 'fal fa-cloud-download',
    '/screens/screens-background': 'fal fa-image',
    // Kiosk
    '/kiosks': 'fal fa-tachometer-alt',
    '/kiosks/dashboard': 'fal fa-tachometer-alt',
    '/kiosks/kiosk-list': 'fal fa-ramp-loading',
    '/kiosks/kiosk-type-list': 'fal fa-album-collection',
    '/kiosks/external-apps': 'fal fa-code-branch',
    '/kiosks/catalog-list': 'fal fa-book-open',
    '/kiosks/catalog-list/product-list': 'fal fa-wine-bottle',
    '/kiosks/catalog-list/category-list': 'fal fal fa-boxes',
    '/kiosks/locations-list': 'fal fa-map-marker-alt',
    '/kiosks/multimedia': 'fal fa-images',
    // Messaging
    '/messaging': 'fal fa-tachometer-alt',
    '/messaging/dashboard': 'fal fa-tachometer-alt',
    '/messaging/message-list': 'fal fa-paper-plane',
    '/messaging/default-list': 'fal fa-magic',
    '/messaging/subscriber-list': 'fal fa-users',
    '/messaging/subscriber-group-list': 'fal fa-users-class',
    '/messaging/multimedia': 'fal fa-images',
    '/messaging/settings': 'fal fa-cog',
    // Security
    '/security/users': 'fal fa-users',
    '/security/location-profiles': 'fal fa-street-view',
    '/security/profiles': 'fal fa-poll-people',
    '/security/security-policies': 'fal fa-lock',
    //search
    'criteria': 'fal fa-search',
    'tag': 'fal fa-search',
    'sortOrder': 'fal fa-search',
    'sortTyp': 'fal fa-search',
    'count': 'fal fa-search',
    'page': 'fal fa-search'
};